import React from 'react'
import PropTypes from 'prop-types'
// import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Helmet } from 'react-helmet'
// import { intl } from 'utils'

export default class Head extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { title, description, image, helmetTitle } = this.props
    return (
      <Helmet>
        <title>{helmetTitle || title}</title>
        {/* <!-- Search Engine --> */}
        <meta name='description' content={description} />
        <meta name='image' content={image} />
        {/* <!-- Schema.org for Google --> */}
        <meta itemProp='name' content={title} />
        <meta itemProp='description' content={description} />
        <meta itemProp='image' content={image} />
        {/* <!-- Twitter --> */}
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:title' content={title} />
        <meta name='twitter:description' content={description} />
        {/* <!-- Open Graph general (Facebook, Pinterest & Google+) --> */}
        <meta name='og:title' content={title} />
        <meta name='og:description' content={description} />
        <meta name='og:image' content={image} />
        <meta name='og:image:width' content='1080' />
        <meta name='og:image:height' content='540' />
        <meta name='og:site_name' content='PayBy' />
        <meta name='og:type' content='website' />
        {/* <!-- ToTok --> */}
        <meta property='og:title' content={title} />
        <meta property='og:description' content={description} />
        <meta property='og:image' content={image} />
      </Helmet>
    )
  }
}

Head.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}
